export enum FunnelStageStep {
  ON_HOLD = 'ON_HOLD',
  STARTED = 'STARTED',
  REQUESTED = 'REQUESTED',
  CHALLENGE = 'CHALLENGE',
  APPROVED = 'APPROVED',
  CONFIRMED = 'CONFIRMED',
  PAID = 'PAID',
  DENIED = 'DENIED',
  DESISTED = 'DESISTED',
  CANCELLED = 'CANCELLED',
  CANCELLED_TEST = 'CANCELLED_TEST',
  EXPIRED = 'EXPIRED',
}
